import { comCorporateMenus } from './comCorporateMenus';
export const getCorporateNavigation = () => comCorporateMenus;
//# sourceMappingURL=index.js.map